import BaseApiRequest from "./BaseApiRequest";
import { CONFIRM_APPLY_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class ConfirmAccountApplyRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = { applicationId: "" };

  constructor(userDetail) {
    super();
    this.body.applicationId = userDetail.applicationId;
    if (userDetail.applicantId) {
      this.body.applicantId = userDetail.applicantId;
    }
    this.body.isThirdPartyAccount = userDetail.isThirdPartyAccount;
    this.body.thirdPartyName = userDetail.thirdPartyName;
    this.body.thirdPartyRelationship = userDetail.thirdPartyRelationship;
    this.body.isDesktop = userDetail.isDesktop;
    this.body.doKyc = userDetail.doKyc;
    this.body.reApply = userDetail.reApply;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(CONFIRM_APPLY_URL);

  getBody = () => this.body;
}
